import React, { useState, useEffect } from "react"
import { Asterisk, Globe, User, CircleUser, LayoutPanelLeft } from "lucide-react"
import { useAppCtx } from 'lib/state';
import { cn } from 'lib/utils';


export default function ClientDataManager({ 
  tagsOwned, 
  ownerTypes, 
  selectFn,
  className="" 
}:{ 
  tagsOwned:any[]
  ownerTypes:string|string[]
  selectFn?:any
  className?:string
}){

  const [ tagtype, setTagtype ] = useState("all")
  const [ tagsToShow, setTagsToShow ] = useState<any[]>([])

  function getTagsByType(){
    if( tagtype === "all" ){
      return tagsOwned
    } else {
      return tagsOwned.filter(tag => tag.type === tagtype)
    }
  }

  function handleTagClick(tag:any){
    if( selectFn ) selectFn(tag)
  }

  useEffect(() => {
    setTagsToShow(getTagsByType())
  },[tagtype])


  return (
    <div className={cn("w-full border border-solid border-slate-700 p-[2px]", className)}>
      <p>Coming soon: write queries against any custom data provided by the client.</p>
    </div>
  )
}